import { splitStreetAndUnit } from '@/utilities/location/splitStreetAndUnit'

export type LocationFields = {
  address?: string | null
  address2?: string | null
  city?: string | null
  state?: string | null
  zip?: string | null
}

/**
 * Whether any location field has a non-blank value.
 */
export function hasLocationInput(fields: LocationFields): boolean {
  return [fields.address, fields.address2, fields.city, fields.state, fields.zip].some((value) =>
    Boolean(value?.trim()),
  )
}

/**
 * Whether Google Address Validation should run.
 * State-only, zip-only, and state+zip submissions are skipped.
 */
export function shouldValidateAddress(fields: LocationFields): boolean {
  return [fields.address, fields.address2, fields.city].some((value) => Boolean(value?.trim()))
}

/**
 * Joins street, unit, and city for the combined Address input display.
 */
export function formatStreetCityDisplay(fields: LocationFields): string {
  return [fields.address, fields.address2, fields.city]
    .map((value) => value?.trim())
    .filter((value): value is string => Boolean(value))
    .join(', ')
}

/**
 * Moves unit/apt/suite off the street line onto address line 2 so it is not stored twice.
 */
export function normalizeLocationFields(fields: LocationFields): LocationFields {
  const { street, unit } = splitStreetAndUnit(fields.address)
  const address2 = fields.address2?.trim() || unit

  return {
    ...fields,
    address: street,
    address2,
  }
}
